<template>
    <footer class="navbar-default">
        <div class="container-fluid">
            <div class="col-lg-8 col-lg-offset-2 col-md-12 col-sm-12 col-xs-12 footer-text">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                        <icon name="copyright" class="icon"></icon>
                        {{ year }} Celtra Inc.
                    </div>
                    <div
                        class="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right"
                        v-if="!isAuthenticated"
                    >
                        <a style="color: #777;" @click.prevent="userLogin" class="icon-label">
                            <icon name="sign-in" class="icon"></icon>Login
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { NotificationsMixin } from "./mixin"

export default {
    name: "Footer",
    mixins: [NotificationsMixin],
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    computed: {
        ...mapGetters(["isAuthenticated"])
    },
    methods: {
        ...mapActions(["login", "getUser"]),
        userLogin() {
            this.login().then(
                token => {
                    this.getUser(token).then(
                        res => {
                            this.showSuccessMsg({
                                title: "Success.",
                                message: "Login successfull."
                            })
                        },
                        error => {
                            this.showErrorMsg({
                                title: "Error!",
                                message: error
                            })
                        }
                    )
                },
                error => {
                    console.error(error)
                }
            )
        }
    }
}
</script>

<style scoped>
footer {
    margin-top: 10px;
}

footer .container-fluid {
    padding: 10px 0px 10px 0px;
}

footer .footer-text {
    padding: 5px;
    color: #777;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue